<div class="flex flex-row gap-2 w-full">
  <img alt="Icon" class="filter-yellow-400 h-6" src="/assets/icons/feather/alert-triangle.svg">
  <div class="flex flex-col gap-2 w-full">
    <h6>Plan próximo a caducar</h6>
    <p class="">
      Este plan está próximo a caducar (Tiempo). Le aconsejamos que comience a preparar su nuevo plan.
      Le recordamos que puede cerrar el plan actual y abrir uno nuevo cuando quiera desde el panel de configuración de
      plan.
    </p>
    <div class="flex flex-col md:flex-row gap-3 pt-4">
      <button class="btn btn-yellow flex flex-row gap-2 items-center"
              style="border-radius: 0.5rem;padding: 0.5rem 1rem">
        <span class="cd-text-md truncate">Recuérdamelo más tarde</span>
      </button>

      <button (click)="editPlan()"
              class="btn btn-yellow-soft flex flex-row gap-2 items-center"
              style="border-radius: 0.5rem;padding: 0.5rem 1rem">
        <span class="cd-text-md truncate">Cerrar plan actual y abrir nuevo</span>
      </button>
    </div>
  </div>
</div>
